import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import AdminAuth from "./pages/AdminAuth";
import AdminDashboard from "./pages/AdminDashboard";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/Admin/AdminRoute";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import AdminNavbar from "./components/Admin/AdminNavbar";
import ProductsType from "./pages/ProductsType";
import Cart from "./pages/Cart";
import { CartProvider } from "./components/Cart/CartContext";
import { VideoProvider } from "./contexts/VideoContext";
import { NavbarProvider } from "./contexts/NavbarContext";
import Product from "./components/Products/Product";
import ContactPage from "./pages/Contact";
import CareGuidePage from "./pages/CareGuide";
import AboutPage from "./pages/AboutPage";
import TopBanner from "./components/Banner";
import ConnectionStatus from "./components/ConnectionStatus";
import OAuthTokenHandler from "./components/OAuthTokenHandler";

import AddProduct from "./components/Products/AddProduct";
import DeleteProduct from "./components/Products/DeleteProduct";
import ModifyProduct from "./components/Products/ModifyProduct";
import Products from "./components/Products/Products";
import FabricationArtisanale from "./pages/FabricationArtisanale";
import FaqPage from "./pages/FaqPage";
import GuideTailles from "./pages/GuideTailles";
import Commandes from "./components/Commande/Commandes";
import Statistiques from "./components/Statistiques";
import MesFavoris from "./components/Favoris/mesFavoris";
import NewsLetter from "./components/NewsLetter";
import AdminFaq from "./components/Admin/AdminFaq";
import AdminFabArt from "./components/Admin/AdminFabArt";
import AdminCareGuide from "./components/Admin/AdminCareGuide";
import AdminCodePromo from "./components/Admin/AdminCodePromo";
import AdminUsers from "./components/Admin/AdminUsers";
import AdminQuickOrders from "./components/Admin/AdminQuickOrders";
import VideoControls from "./components/VideoControls";

function AppWrapper() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <>
      {/* Composant de gestion des notifications de connexion */}
      <ConnectionStatus />
      
      {/* Composant de gestion du token OAuth Google */}
      <OAuthTokenHandler />
      
      {isAdminPage ? <TopBanner /> : <TopBanner />}

      {/* ✅ Affiche la bonne navbar selon le contexte */}
      {isAdminPage ? <AdminNavbar /> : <Navbar />}

      <div className="App">
        <Routes>
          {/* Routes utilisateur */}
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/conseils" element={<CareGuidePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/fabrication" element={<FabricationArtisanale />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/guide-tailles" element={<GuideTailles />} />
          <Route
            path="/products/femme"
            element={<ProductsType type="femme" />}
          />
          <Route
            path="/products/homme"
            element={<ProductsType type="homme" />}
          />
          <Route
            path="/products/enfant"
            element={<ProductsType type="enfant" />}
          />
          <Route
            path="/products/collections-speciales"
            element={<ProductsType type="collections speciales" />}
          />
          <Route path="/product/:id" element={<Product />} />

          <Route
            path="/cart"
            element={
              <PrivateRoute>
                <Cart />
              </PrivateRoute>
            }
          />
          <Route
            path="/favoris"
            element={
              <PrivateRoute>
                <MesFavoris />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />

          {/* Routes admin */}
          <Route path="/admin/login" element={<AdminAuth />} />

          <Route
            path="/admin/dashboard"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/ajout-produit"
            element={
              <AdminRoute>
                <AddProduct />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/delete-produit"
            element={
              <AdminRoute>
                <DeleteProduct />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/modify-produit"
            element={
              <AdminRoute>
                <ModifyProduct />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/produits"
            element={
              <AdminRoute>
                <Products />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/commandes"
            element={
              <AdminRoute>
                <Commandes />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/quick-orders"
            element={
              <AdminRoute>
                <AdminQuickOrders />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/newsletter"
            element={
              <AdminRoute>
                <NewsLetter />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/statistiques"
            element={
              <AdminRoute>
                <Statistiques />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/faq"
            element={
              <AdminRoute>
                <AdminFaq />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/fabrication-artisanale"
            element={
              <AdminRoute>
                <AdminFabArt />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/care-guide"
            element={
              <AdminRoute>
                <AdminCareGuide />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/codes-promo"
            element={
              <AdminRoute>
                <AdminCodePromo />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/admins"
            element={
              <AdminRoute>
                <AdminUsers />
              </AdminRoute>
            }
          />

        </Routes>
      </div>
      <VideoControls />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastStyle={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "14px",
          borderRadius: "12px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
        }}
      />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <VideoProvider>
          <NavbarProvider>
            <AppWrapper />
          </NavbarProvider>
        </VideoProvider>
      </CartProvider>
    </BrowserRouter>
  );
}
